/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeActivityPhase } from './workingModeActivityPhase';
import type { WorkingModeActivityCurrent } from './workingModeActivityCurrent';
import type { WorkingModeActivityDesired } from './workingModeActivityDesired';
import type { WorkingModeEntityRef } from './workingModeEntityRef';
import type { WorkingModeActivityWritePath } from './workingModeActivityWritePath';

export interface WorkingModeActivity {
  id: string;
  kind: string;
  phase: WorkingModeActivityPhase;
  optional?: boolean;
  dependsOn?: string[];
  current?: WorkingModeActivityCurrent;
  desired?: WorkingModeActivityDesired;
  entityRefs?: WorkingModeEntityRef[];
  writePath: WorkingModeActivityWritePath;
}
